// Sharp Cut data table. Panel header row, mono numerics, 1px hairline dividers.
// columns: [{key, label, align?, render?(row)}]
export const DataTable = ({ columns, rows, cap, totalCount, testId, moreLabel }) => {
  const shown = cap ? rows.slice(0, cap) : rows;
  const total = totalCount ?? rows.length;
  const more = total - shown.length;
  const cell = (col, row) => (col.render ? col.render(row) : row[col.key] ?? "—");
  const isNum = (col) => col.align === "right";

  return (
    <div data-testid={testId}>
      {/* Desktop */}
      <div className="hidden md:block overflow-x-auto border border-[color:var(--hairline)]">
        <table className="w-full text-sm border-collapse">
          <thead className="bg-[color:var(--panel)]">
            <tr className="border-b-2 border-[color:var(--ink)]">
              {columns.map((c) => (
                <th
                  key={c.key}
                  className={`px-4 py-3 text-[11px] font-semibold uppercase tracking-[0.14em] text-[color:var(--ink)] ss-mono ${
                    isNum(c) ? "text-right" : "text-left"
                  }`}
                >
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {shown.map((row, i) => (
              <tr
                key={i}
                className="border-b border-[color:var(--hairline)] hover:bg-[color:var(--green-soft)]/60 transition-colors last:border-b-0"
              >
                {columns.map((c) => (
                  <td
                    key={c.key}
                    className={`px-4 py-3 text-[color:var(--ink)] ${
                      isNum(c) ? "text-right ss-mono" : "text-left"
                    }`}
                  >
                    {cell(c, row)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Mobile stacked cards */}
      <div className="md:hidden space-y-3">
        {shown.map((row, i) => (
          <div key={i} className="border-2 border-[color:var(--ink)] p-4 bg-white">
            <div className="font-semibold text-[color:var(--ink)] mb-3 text-sm">{cell(columns[0], row)}</div>
            <dl className="grid grid-cols-2 gap-x-4 gap-y-2">
              {columns.slice(1).map((c) => (
                <div key={c.key} className="flex flex-col">
                  <dt className="ss-mono text-[10px] uppercase tracking-[0.12em] text-[color:var(--grey)]">{c.label}</dt>
                  <dd className={`text-sm text-[color:var(--ink)] ${isNum(c) ? "ss-mono" : ""}`}>{cell(c, row)}</dd>
                </div>
              ))}
            </dl>
          </div>
        ))}
      </div>
      {more > 0 && (
        <p className="ss-mono text-xs text-[color:var(--grey)] mt-3 uppercase tracking-[0.08em]">
          +{more} more {moreLabel || "in your full action list"}
        </p>
      )}
    </div>
  );
};
